import { MaxRectAction, SET_MAXRECT, MaxRectData, RESET_MAXRECT} from '../../Actions/Atlas/maxrect.action';
import { RESET_ALL } from '../../Actions/globals.actions';

export default (state: MaxRectData[] = [], action: MaxRectAction ) => {
    switch (action.type) {
        case SET_MAXRECT: {
            return action.payload;
        }
        case RESET_ALL: {
            return [];
        }
        case RESET_MAXRECT: {
            return [];
        }
        default: 
            return state;
    }
}